// extracted by mini-css-extract-plugin
export default {"root":"ClientInvestorCard_root__aZo48","investorName":"ClientInvestorCard_investorName__FkyoX","lineThrough":"ClientInvestorCard_lineThrough__ntMtX"};